import { NavLink } from 'react-router-dom';
import { FolderKanban, History, LayoutDashboard, Plus, Settings } from 'lucide-react';
import { cn } from '@/utils/cn';
import { Logo } from './Logo';

export interface NavItem {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/analyses/new', label: 'New Analysis', icon: Plus },
  { to: '/projects', label: 'Projects', icon: FolderKanban },
  { to: '/history', label: 'History', icon: History },
  { to: '/settings', label: 'Settings', icon: Settings },
];

export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav aria-label="Main" className="flex flex-col gap-0.5">
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-surface-hover font-medium text-fg'
                  : 'text-muted hover:bg-surface-hover hover:text-fg',
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  className={cn('h-4 w-4 shrink-0', isActive ? 'text-accent' : 'text-subtle')}
                  aria-hidden="true"
                />
                {item.label}
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}

/** Desktop sidebar. Hidden below lg, where the drawer takes over. */
export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 border-r border-border bg-surface/40 lg:flex lg:flex-col">
      <div className="flex h-14 items-center border-b border-border px-4">
        <Logo />
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        <SidebarNav />
      </div>
      <div className="border-t border-border p-3">
        <p className="text-xs leading-relaxed text-subtle">
          Extracts a site&apos;s visual language into a reusable design.md.
        </p>
      </div>
    </aside>
  );
}
